module.exports = __webpack_public_path__ + "static/img/sz.cfb8269f.svg";